"use strict";

exports.__esModule = true;
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const TimerCircleIcon = ({
  title,
  ...otherProps
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    xmlns: "http://www.w3.org/2000/svg",
    ...otherProps,
    children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M36.63 44.234c-.33 0-.65-.13-.88-.37-.23-.23-.37-.55-.37-.88 0-.08.01-.16.03-.25.01-.08.04-.15.07-.23.03-.07.07-.15.11-.21.05-.07.1-.14.16-.2.46-.46 1.3-.46 1.76 0 .24.24.37.56.37.89 0 .33-.13.65-.37.88-.23.24-.55.37-.88.37",
        fill: "#4caa50",
        className: "svg-fill-primary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M57.34 61.286a1.827 1.827 0 113.654.001 1.827 1.827 0 01-3.654-.001",
        fill: "#fefefe",
        className: "svg-fill-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M36.291 72.004C16.579 72.004.542 55.967.542 36.255.542 16.542 16.579.504 36.291.504c19.712 0 35.749 16.038 35.749 35.751 0 7.856-2.499 15.309-7.226 21.552a1.75 1.75 0 11-2.791-2.112c4.264-5.631 6.517-12.353 6.517-19.44 0-17.783-14.467-32.251-32.249-32.251-17.782 0-32.249 14.468-32.249 32.251 0 17.782 14.467 32.249 32.249 32.249a32.152 32.152 0 0017.166-4.943 1.75 1.75 0 011.865 2.961 35.646 35.646 0 01-19.031 5.482",
        fill: "#fefefe",
        className: "svg-fill-secondary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M42.32 30.1H30.111a1.25 1.25 0 010-2.5H42.32a1.25 1.25 0 010 2.5",
        fill: "#4caa50",
        className: "svg-fill-primary"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M28.825 48.586h15.431l-3.91-7.708-2.68-3.689a1.252 1.252 0 010-1.47l2.68-3.69 3.91-7.708h-15.43l3.91 7.708 2.68 3.69a1.253 1.253 0 010 1.469l-2.68 3.69-3.91 7.708zm17.466 2.5h-19.5a1.249 1.249 0 01-1.115-1.815l4.874-9.612a1.21 1.21 0 01.103-.169l2.205-3.036-2.205-3.036a1.271 1.271 0 01-.103-.169l-4.875-9.612a1.25 1.25 0 011.115-1.816h19.501a1.25 1.25 0 011.115 1.816l-4.875 9.612c-.03.059-.065.115-.103.169l-2.207 3.036 2.207 3.035c.038.054.073.111.103.17l4.875 9.612a1.249 1.249 0 01-1.115 1.815z",
        fill: "#4caa50",
        className: "svg-fill-primary"
      })]
    })]
  });
};

TimerCircleIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(TimerCircleIcon);

exports.default = _default;